export const apiBaseURL = "https://obamain.tracktrolley.com";
export const zoomRange = 0.005;
export const apiKey = "org.onebusaway.iphone";
export const fetchInterval = 60 * 1000;
export const zoomBusOnlyCircle = 11.5;
export const privacyPolicyUrl = "https://tracktrolley.com/docs/privacy.html";

export const bctBaseUrl = "https://bctapi.tracktrolley.com";

export const indigoColorForMiamiDade = "#6610f2";

export const linksObject = [
  {
    url: "https://sweetwater.tracktrolley.com", //* 33174
    name: "Sweetwater",
    variant: "primary",
    color: "#0d6efd",
    disabled: false,
  },
  {
    url: "https://doral.tracktrolley.com", //* 13
    name: "Doral",
    variant: "info",
    color: "#0dcaf0",
    disabled: false,
  },
  {
    url: "https://comb.tracktrolley.com", //* 2362
    name: "Miami Beach",
    variant: "success",
    color: "#198754",
    disabled: false,
  },
  {
    url: "https://fll.tracktrolley.com", //* 33311
    name: "Fort Lauderdale",
    variant: "danger",
    color: "#dc3545",
    disabled: false,
  },
  {
    url: "https://ms.tracktrolley.com", //* MS
    name: "Miami Springs",
    variant: "warning",
    color: "#ffc107",
    disabled: false,
  },
  {
    url: "https://pb.tracktrolley.com", //* 16
    name: "Pompano Beach",
    variant: "secondary",
    color: "#6c757d",
    disabled: false,
  },
  {
    url: "https://bct.tracktrolley.com", //* BCT
    name: "Broward County Transit",
    variant: "dark",
    color: "#212529",
    disabled: false,
  },
  {
    url: "#", //* 33132
    name: "Miami-Dade",
    variant: "light",
    color: indigoColorForMiamiDade,
    disabled: true,
  },
];
